import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useCallback } from "react";
import api, { SystemLogDto } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";
import { dayjsUtcFormat } from "../../utils";

export interface SystemLogGridProps {
  onRowSelected?: (row: SystemLogDto | null) => void;
}

export const SystemLogGrid = (props: SystemLogGridProps) => {
  const { onRowSelected } = props;

  const loadData = useCallback(async (page: number, size: number, sort: string): Promise<PaginationData<SystemLogDto>> => {
    return await api.systemLog.find({ page, size, sort } as any);
  }, []);

  const columns: GridColDef<SystemLogDto>[] = [
    { field: "eventName", headerName: "Event", width: 150, editable: false, sortable: true, filterable: false },
    { field: "log", headerName: "Log", minWidth: 200, flex: 400, editable: false, sortable: false, filterable: false },
    { field: "isError", headerName: "error", width: 60, editable: false, sortable: true, filterable: false, align: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
    { field: "createdAt", headerName: "time UTC", width: 150, editable: false, sortable: true, filterable: false, valueFormatter: (p) => dayjsUtcFormat(p.value) },
  ];

  return <PaginatedDataGrid loadData={loadData} columns={columns} onRowSelected={onRowSelected} />;
};
